<template>
  <div>
    <div class="grid_supplier">
      <v-card elevation="3" class="mr-sm-2 mr-md-2 mr-lg-2 mr-xl-2" @click="redirect_page('/supplier')">
        <div class="pa-3">
          <div class="font_supplier"><b>จำนวนซัพพลายเออร์ทั้งหมด</b></div>
          <div class="grid_count mt-2">
            <div class="mx-auto">
              <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_supplier_list" :src="img_supplier_list"/>
            </div>
            <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(total_supplier) }}</b></div>
          </div>
        </div>
      </v-card>
      <div class="grid_supplier_half">
        <v-card elevation="3" class="ml-sm-2 ml-md-2 ml-lg-2 ml-xl-2" @click="redirect_page('/purchase')">
          <div class="pa-3">
            <div class="font_supplier"><b>จำนวนการสั่งซื้อที่คงค้าง (เข้าไม่ครบ)</b></div>
            <div class="grid_count mt-2">
              <div class="mx-auto">
                <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_standing" :src="img_standing"/>
              </div>
              <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(ordercount) }}</b></div>
            </div>
          </div>
        </v-card>
        <v-card elevation="3" class="ml-sm-4 ml-md-4 ml-lg-4 ml-xl-4" @click="redirect_page('/purchase')">
          <div class="pa-3">
            <div class="font_supplier"><b>จำนวนการสั่งซื้อที่กำลังดำเนินการ (ใหม่)</b></div>
            <div class="grid_count mt-2">
              <div class="mx-auto">
                <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_process" :src="img_process"/>
              </div>
              <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(ordercountprogress) }}</b></div>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import {formatNumber} from "@/js/handler";
import img_supplier_list from "@/assets/3420151.png";
import img_standing from "@/assets/fast-delivery.png";
import img_process from "@/assets/product_report.png";
import {HTTP} from "@/axios";

export default {
  name: "Supplier_total",
  data() {
    return {
      img_supplier_list: img_supplier_list,
      img_standing: img_standing,
      img_process: img_process,
      total_supplier: 0,
      ordercount: 0,
      ordercountprogress: 0,
    }
  },
  methods: {
    format_number: function (value) {
      return formatNumber(value)
    },
    get_data() {
      HTTP.post('/dashboards/ordersuppliertotal')
          .then((res) => {
            if (res.data.success === true) {
              this.total_supplier = res.data.object.total_supplier
              this.ordercount = res.data.object.ordercount
              this.ordercountprogress = res.data.object.ordercountprogress
            }
          })
    },
    redirect_page(link_url) {
      this.$router.push(link_url)
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_supplier {
  display: grid;
  grid-template-columns: 25% 75%;
  grid-gap: 15px 0;
}
.grid_supplier_half {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px 0;
}
.grid_count {
  display: grid;
  grid-template-columns: 25% 75%;
}
.font_supplier {
  font-size: 20px !important;
}
@media only screen and (max-width: 1180px) {
  .grid_supplier {
    display: grid;
    grid-template-columns: 33% 67%;
    grid-gap: 15px 0;
  }
  .grid_supplier_half {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
  .font_supplier {
    font-size: 13px !important;
  }
}
@media only screen and (max-width: 500px) {
  .grid_supplier {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_supplier_half {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .font_supplier {
    font-size: 16px !important;
  }
}
</style>
